import _defineProperty from "D:\\Portal_repos\\VE_R2.9\\SWIFMod_CC_Portal_11_4_1\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "D:\\Portal_repos\\VE_R2.9\\SWIFMod_CC_Portal_11_4_1\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { SET_ASYNC_DATA, SET_LOADING } from './types';
export var reducer = function reducer(state, _ref) {
  var type = _ref.type,
    payload = _objectWithoutProperties(_ref, ["type"]);
  switch (type) {
    case SET_ASYNC_DATA:
      {
        var asyncData = payload.asyncData,
          numberOfRows = payload.numberOfRows;
        return _objectSpread({}, state, {
          asyncData: asyncData,
          numberOfRows: numberOfRows
        });
      }
    case SET_LOADING:
      {
        var loading = payload.loading;
        return _objectSpread({}, state, {
          loading: loading
        });
      }
    default:
      return state;
  }
};